import React, { FC, memo, useEffect } from 'react';
import { getTimeWithTimeZone, timezone } from 'utils/helpers/momentTime';
import moment from 'moment';
import { connect, useDispatch } from 'react-redux';
import { IRootState } from 'store';
import { IEvents, MapTemplate } from 'types';
import _ from 'lodash';
import { getScholar } from 'actions/scholars';
import { defaultMapTemplate } from 'utils/constants/map';
import MobileService from 'services/mobile';
import styles from 'components/common/calendar/index.module.scss';
import root from './index.module.scss';
import Event from './event';

const mapStateToProps = (state: IRootState) => ({
  activeScholarId: state.users.userData?.activeScholarId,
  scholar: state.scholars.scholar,
});

interface ITableProps extends ReturnType<typeof mapStateToProps> {
  days: moment.Moment[][];
  weekCount: number;
  daysToShow: number;
  events: IEvents[];
  timeLine: string[];
}
const Cells: FC<ITableProps> = ({
  days,
  weekCount,
  daysToShow,
  timeLine,
  events,
  activeScholarId,
  scholar,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (activeScholarId) {
      dispatch(getScholar(activeScholarId));
    }
  }, [activeScholarId, dispatch]);

  const template = scholar?.settings?.mapTemplate || defaultMapTemplate;

  const renderBlocks = (
    event: IEvents,
    timeStamp: string,
    day: moment.Moment,
    mapTemplate: MapTemplate
  ) => {
    let render = null;
    const startTime = getTimeWithTimeZone(
      event.startTimeStr || '00:00',
      'HH:mm'
    );
    const eventTime = moment(
      `${moment(startTime, 'HH:mm').format('LT')} ${moment(day).format(
        'MMM, D'
      )}`
    );
    const position = moment(`${timeStamp} ${moment(day).format('MMM, D')}`);
    const diff = eventTime.diff(position, 'minutes');

    if (
      startTime === moment(timeStamp, 'LT').format('HH:mm') ||
      (diff <= 14 && diff > 0)
    ) {
      if (
        day.format('YYYY-MM-DD') ===
        moment(event.startTime)
          .utc()
          .add(timezone, 'minutes')
          .format('YYYY-MM-DD')
      ) {
        render = (
          <Event
            diff={diff}
            daysToShow={daysToShow}
            key={event.id}
            day={day}
            event={event}
            mapTemplate={mapTemplate}
          />
        );
      }
    }
    return render;
  };

  return (
    <div className={styles.days}>
      {!_.isEmpty(days) &&
        days[weekCount].map((day: moment.Moment) => (
          <div
            key={day.toString()}
            style={daysToShow === 1 ? { width: '100%' } : {}}
            className={`${styles.day} ${root.day}`}
          >
            {timeLine.map((timeStamp: string) => (
              <div
                key={timeStamp}
                className={`${styles.timeLine} ${root.timeLine} ${
                  MobileService.isMobile ? root.tablet : ''
                }`}
              >
                {!_.isEmpty(events) &&
                  events.map((e: IEvents) =>
                    renderBlocks(e, timeStamp, day, template)
                  )}
              </div>
            ))}
          </div>
        ))}
    </div>
  );
};

export default memo(connect(mapStateToProps)(Cells));
